import { Component, Input, OnDestroy, signal } from "@angular/core";
import { ReelsComponent } from "../reels/reels.component";
import { FooterService } from "@src/app/servicios/footer.service";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-reels-loader",
  imports: [ReelsComponent, NgIf],
  templateUrl: "./reels-loader.component.html",
  styleUrl: "./reels-loader.component.scss",
})
export class ReelsLoaderComponent implements OnDestroy {
  @Input() newsId: number;

  showReels = signal(false);
  showLoader = signal(true);

  constructor(private footerService: FooterService) {
    this.footerService.setShowFooter(false);
  }

  receive() {
    this.showReels.set(true);
  }

  hideLoader() {
    this.showLoader.set(false);
  }

  ngOnDestroy(): void {
    this.footerService.setShowFooter(true);
  }
}
